<template>
  <div>
    <apexcharts height="250" type="line" :options="chartOptions" :series="series"></apexcharts>
  </div>
</template>

<script>
import { defineComponent, computed } from "vue";
import VueApexCharts from "vue3-apexcharts";
export default defineComponent({
  components: {
    apexcharts: VueApexCharts,
  },
  props: {
    data: { required: true, type: Object },
    user: { required: true, type: Object },
  },
  setup(props) {
    const user = computed(() => props.user);
    const chartOptions = computed(() => {
      return {
        chart: {
          id: "line-date",
          type: "line",
          height: 350,
          zoom: {
            autoScaleYaxis: true,
          },
          toolbar: {
            show: false,
          },
        },
        title: {
          text: user.value
            ? `Tipificaciones por hora de “${user.value.fullname}”`
            : "Tipificaciones por hora",
          align: "center",
        },
        stroke: {
          width: 2,
          curve: "smooth",
        },
        colors: ["#EAFF8F", "#ADC6FF", "#FFBB96"],
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 0,
          style: "hollow",
        },
        xaxis: {
          categories: [
            "00 a 01",
            "01 a 02",
            "02 a 03",
            "03 a 04",
            "04 a 05",
            "05 a 06",
            "06 a 07",
            "07 a 08",
            "08 a 09",
            "09 a 10",
            "10 a 11",
            "11 a 12",
            "12 a 13",
            "13 a 14",
            "14 a 15",
            "15 a 16",
            "16 a 17",
            "17 a 18",
            "18 a 19",
            "19 a 20",
            "20 a 21",
            "21 a 22",
            "22 a 23",
          ],
          title: {
            text: "Hora",
          },
        },
        yaxis: {
          title: {
            text: "Número de tipificaciones",
          },
        },
        tooltip: {
          x: {
            formatter: function (val) {
              return parseInt(val) - 1 + " a " + val + " Horas";
            },
          },
        },
      };
    });
    return {
      chartOptions,
    };
  },
  computed: {
    series() {
      return [
        {
          name: "Contacto Directo",
          data: this.getDataDC(this.data),
        },
        {
          name: "Contacto Indirecto",
          data: this.getDataIC(this.data),
        },
        {
          name: "No Contacto",
          data: this.getDataNC(this.data),
        },
      ];
    },
  },
  methods: {
    getDataDC(data) {
      const arr = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      data.forEach((item) => (arr[Number(item.hour_management)] = item.direct_contact));
      return arr;
    },
    getDataIC(data) {
      const arr = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      data.forEach((item) => (arr[Number(item.hour_management)] = item.indirect_contact));
      return arr;
    },
    getDataNC(data) {
      const arr = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      data.forEach((item) => (arr[Number(item.hour_management)] = item.no_contact));
      return arr;
    },
  },
});
</script>

<style></style>
